import SidebarMenu from '../SidebarMenu/SidebarMenu.vue';
import Breadcrumb from '../../common/Breadcrumb/Breadcrumb.vue';

export default {
  components: { SidebarMenu, Breadcrumb },
};
